<template>
    <div>

        <config-main-title>
            Duplicidade de Pacientes
        </config-main-title>

        <div class="row mb-3 w3-animate-opacity">

            <div class="col col-12 col-md-6">

                <az-input 
                    placeholder="Paciente"
                    icon="fas fa-user"
                    type="autocomplete" 
                    optionsMode="aql"
                    service="pacientes.index"
                    optionsDisplay="search"
                    :optionsParm="{ id_outro: -1 }"
                    ref="info_paciente"
                    v-model="paciente" 
                    :edicao="ativado"
                    @input="selecionarPaciente()" />

            </div>

            <div class="col col-12 col-md-6" v-if="paciente && dados && !dados.length">

                <az-input 
                    placeholder="Buscar Outro Paciente"
                    icon="fas fa-user"
                    type="autocomplete" 
                    optionsMode="aql"
                    service="pacientes.index"
                    optionsDisplay="search"
                    :optionsParm="{ id_outro: -1 }"
                    ref="info_paciente"
                    v-model="outro_paciente" 
                    :edicao="ativado"
                    @input="selecionarPaciente()" />

            </div>

        </div>

        <div v-if="!paciente"> 

            <az-empty-state
                :msg="paciente ? 'Nenhum paciente duplicado encontrado.' : 'Selecione o paciente.'" 
                :icon="paciente ? 'fas fa-clone' : 'fa fa-search'"
                v-if="!paciente" />

            <p class="alert alert-info">
                A verificação de duplicidade é feita baseada no nome, sexo, data de nascimento e CPF.<br>
                A validação do CPF verifica se os pacientes possuem CPFs diferentes.
            </p>

        </div>

        <div class="row" v-if="paciente">
            <div class="col col-12 col-md-6">
                <identificacao-paciente :pacientes="[paciente]" tipo="origem" />
            </div>

            <div class="col col-12 col-md-6">

                <template v-if="dados && !dados.length && outro_paciente">
                    <div v-if="validar_outro_paciente()" class="alert alert-danger">
                        <strong>
                            <i class="fa-solid fa-triangle-exclamation fa-fw mr-2"></i>
                            {{ validar_outro_paciente() }}
                        </strong>
                    </div>

                    <identificacao-paciente :pacientes="[outro_paciente]" :base="paciente" tipo="destino" @unir="confirmarUniao"  />
                </template>
                
                <az-empty-state
                    :msg="paciente ? 'Nenhum paciente duplicado encontrado.' : 'Selecione o paciente.'" 
                    :icon="paciente ? 'fas fa-clone' : 'fa fa-search'"
                    v-else-if="!dados || !dados.length" />

                <identificacao-paciente :pacientes="dados" :base="paciente" tipo="destino" @unir="confirmarUniao" v-else />

            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="confirmaUnirModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Confirmação</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <p class="alert alert-danger">
                            <strong>
                                <i class="fa-solid fa-triangle-exclamation fa-fw mr-2"></i>
                                Essa operação é irreversível!
                            </strong>
                        </p>

                        <span class="lead">Confirma unir o cadastro com o paciente de origem?</span>

                        <div class="alert alert-info mt-3">
                            Os dados que serão considerados como base do cadastro, serão os dados do <strong>paciente de origem</strong>. <br><br>
                            Caso algum dado não exista no paciente de origem, mas exista no paciente que está sendo unido, o cadastro do paciente de origem será completado com essa informação.
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit color="danger" @click="unir()">Unir</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import IdentificacaoPaciente from '../shared/IdentificacaoPaciente.vue';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            paciente: "",
            outro_paciente: "", 
            destino: "",
            dados: [],
            ativado: false, 
        }
    },

    components: { 
        AzInput,
        AzEmptyState, 
        IdentificacaoPaciente, 
        ConfigMainTitle,
        AzSubmit, 
    },

    methods: { 
        confirmarUniao (paciente) { 
            this.destino = paciente;
            $('#confirmaUnirModal').modal('show');
        },

        unir () { 

            this.$util.atualizar(this, { 
                service: 'pacientes',
                func: 'unir',
                dados: { 
                    id_origem: this.paciente.id_pessoa,
                    id_destino: this.destino.id_pessoa,
                },
                modal: "confirmaUnirModal",
                toast: true,
                callback: (res) => { 
                    this.paciente = res;
                    this.destino = null;
                    this.outro_paciente = "";
                },
                final: () => { 
                    this.selecionarPaciente();
                }
            });

        },

        selecionarPaciente () { 
            if ( !this.paciente ) 
                return;

            this.destino = null;

            this.$util.load(this, { 
                service: 'pacientes',
                parms: { 
                    search: this.paciente.st_nome,
                    ch_sexo: this.paciente.cadastro.ch_sexo,
                    dt_nascimento: this.paciente.cadastro.dt_nascimento,
                    st_cpf: this.paciente.cadastro.st_cpf,
                    id_outro: this.paciente.id_pessoa,
                },
            });
        },

        validar_outro_paciente () { 

            if ( !this.paciente || !this.paciente.cadastro || !this.outro_paciente || !this.outro_paciente.cadastro ) { 
                return "Paciente não identificado.";
            }

            if ( this.paciente.cadastro.dt_nascimento != this.outro_paciente.cadastro.dt_nascimento ) { 
                return "Data de nascimento divergente";
            }

            if ( this.paciente.cadastro.ch_sexo != this.outro_paciente.cadastro.ch_sexo ) { 
                return "Sexo divergente";
            }

            if ( this.paciente.cadastro.st_cpf && this.outro_paciente.cadastro.st_cpf && this.paciente.cadastro.st_cpf != this.outro_paciente.cadastro.st_cpf ) { 
                return "CPF divergente";
            }

            let nome = _.get(this.paciente.st_nome.split(' '), '0');

            if ( nome != this.outro_paciente.st_nome.slice(0,nome.length) ) { 
                return "Nome divergente";
            }

            return "";

        }
    },

    mounted() { 
        this.$util.valid_permissao(this, 90, () => { 
            this.ativado = true;
        });

        this.$store.commit("setBreadcrumb", [
            { name: "Configurações", path: "/cadastros" },
            { name: "Duplicidade de Pacientes", path: "/config/duplicidade" }
        ]);
    }
}
</script>